const postEquipmentServices = {
  toastr: 'Serviço adicionado',
  massService: 'Serviço em massa adicionado',
  toastrError: 'Tipo de Serviço já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default postEquipmentServices;
